import ReactDOM from "react-dom/client";
import ConfirmModal from "../components/shared/ConfirmModal";

interface ConfirmOptions {
    title: string;
    description?: string;
    isDelete?: boolean; 
}

export const confirmDialog = (options: ConfirmOptions): Promise<boolean> => {
    
    return new Promise((resolve) => {

        const container = document.createElement('div');
        document.body.appendChild(container);
        const root = ReactDOM.createRoot(container);

        const cleanup = () => {
            root.unmount();
            document.body.removeChild(container);
        };

        const handleResult = (confirmed: boolean) => {
            cleanup();
            resolve(confirmed);
        };

        root.render(
            <ConfirmModal
                title={options.title}
                description={options.description}
                informationConfirm={!options.isDelete}
                onResult={handleResult}
            />
        );
        
    });
};
